export class InputSelectOptionModel {
  constructor(public value: any,
              public label: string) {
  }
}



// WEBPACK FOOTER //
// ./src/app/form/input/select/option.model.ts